import React from "react";
import { Allergy } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import ListCard from "./ListCard";
import NotesCard from "./Patient/components/NotesCard";

interface Props {
  patientRequests: string[];
  patientTasks: string[];
  patientAllergies: Allergy[];
  patientMedicalNotes: string | null;
}

const VisitInfoCards = (props: Props) => {
  return (
    <React.Fragment>
      <ListCard title={translate(STRINGS.PATIENT_REQUESTS)} items={props.patientRequests} />

      <ListCard title={translate(STRINGS.MAIN_TASKS)} items={props.patientTasks} />

      {props.patientAllergies.length > 0 ? (
        <ListCard
          title={translate(STRINGS.ALLERGIES)}
          items={props.patientAllergies.map((allergy) => allergy.name)}
        />
      ) : (
        <NotesCard title={translate(STRINGS.ALLERGIES)} notes={null} />
      )}

      <NotesCard title={translate(STRINGS.MEDICAL_INFORMATION)} notes={props.patientMedicalNotes} />
    </React.Fragment>
  );
};

export default VisitInfoCards;
